export class TicketDetailContext {

    public bookingId: string = ""
    constructor() {

    }
}